<div fxLayout="column" style="height: auto; overflow: hidden;">
    <div fxFlex fxLayout="row" *ngIf="hasFilter" fxLayoutGap="10">
        <!-- Botão customizado (à esquerda) -->
        <div fxFlex="initial" *ngIf="showCustomButton">
            <button
                mat-mini-fab
                [color]="customButtonColor"
                [matTooltip]="customButtonTooltip"
                (click)="customButtonClick.emit()">
                <mat-icon>{{customButtonIcon}}</mat-icon>
            </button>
        </div>

        <!-- Campo de pesquisa (ao centro) -->
        <div fxFlex="100" class="search-input">
            <mat-form-field *ngIf="!hideFilter" style="width: 100%;">
                <input
                    matInput
                    #input
                    (keyup)="applyFilter(filterValue)"
                    [(ngModel)]="filterValue"
                    (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
                    (onModelChange)="keyboardService.onInputChange($event, input)"
                    placeholder="Pesquisar" />
            </mat-form-field>
        </div>

        <!-- Botão de adicionar (à direita) -->
        <div fxFlex="initial" *ngIf="hasAdd">
            <button mat-fab class="btn-add"
                (click)="openNew.emit({ userType: userType })">
                <mat-icon
                    aria-label="Example icon-button with a heart icon">add</mat-icon>
            </button>
        </div>
    </div>

    <div class="mat-elevation-z8 container-wrapper"
        style="display: flex; flex-direction: column; overflow: hidden; height: auto;">
        <ng-content select="[header]"></ng-content>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="loading-container"
            fxLayoutAlign="center center" style="flex: 1;">
            <mat-spinner diameter="50"></mat-spinner>
        </div>

        <!-- Select All Option (quando aplicável) -->
        <div *ngIf="hasSelectConfig() && !isLoading"
            class="select-all-container">
            <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="isAllSelected()"
                [indeterminate]="isMasterCheckboxIndeterminate()"
                [aria-label]="'Selecionar todos os itens'">
                Selecionar Todos
            </mat-checkbox>
        </div>

        <!-- Contador de registros -->
        <div
            *ngIf="!isLoading && dataSource && dataSource.data && dataSource.data.length > 0"
            class="items-counter" fxLayout="row"
            fxLayoutAlign="space-between center">
            <span class="total-counter">
                <strong>{{ length || dataSource.data.length }}</strong> itens
                encontrados
            </span>
            <span class="status-counter">
                <span class="active-counter"
                    [class.selected]="activeFilter === 'active'"
                    (click)="toggleActiveFilter('active')"
                    style="cursor: pointer;">
                    <mat-icon
                        class="counter-icon active">check_circle</mat-icon>
                    <strong>{{ getActiveItemsCount() }}</strong> Ativos
                </span>
                <span class="separator" style="margin: 0 8px;">|</span>
                <span class="inactive-counter"
                    [class.selected]="activeFilter === 'inactive'"
                    (click)="toggleActiveFilter('inactive')"
                    style="cursor: pointer;">
                    <mat-icon class="counter-icon inactive">cancel</mat-icon>
                    <strong>{{ getInactiveItemsCount() }}</strong> Desativados
                </span>
            </span>
        </div>

        <!-- Mensagem de Nenhum Resultado -->
        <div
            *ngIf="!isLoading && (!dataSource?.data || dataSource.data.length === 0)"
            class="no-results" fxLayoutAlign="center center" fxLayout="column"
            fxFlex style="flex: 1; min-height: 300px;">
            <mat-icon
                style="font-size: 64px; width: 64px; height: 64px; margin-bottom: 24px; opacity: 0.6;">search_off</mat-icon>
            <span
                style="font-size: 18px; margin-bottom: 16px; color: rgba(0,0,0,0.6);">Nenhum
                registro encontrado com os filtros aplicados.</span>
            <button mat-raised-button color="primary"
                (click)="filterValue = ''; applyFilter('')"
                style="margin-top: 16px;">
                <mat-icon>refresh</mat-icon> Limpar e Recarregar
            </button>
        </div>

        <!-- Grid de Cards -->
        <div
            *ngIf="!isLoading && dataSource?.data && dataSource.data.length > 0"
            class="cards-container"
            style="flex: 1; overflow-y: auto; max-height: calc(100vh - 420px); min-height: calc(100vh - 420px)">
            <!-- Card para cada item no dataSource -->
            <mat-card *ngFor="let item of dataSource.data"
                class="item-card"
                [class.selected]="isItemSelected(item) || selectedItem?.id === item.id"
                [class.disabled]="item[lockProperty] === false || item.isActive === false"
                (click)="selectItem(item)">

                <!-- Header do Card -->
                <div class="card-header">
                    <!-- Imagem ou Avatar do Card -->
                    <div class="card-image"
                        *ngIf="cardImageProperty || cardTitleProperty">
                        <div class="placeholder-image"
                            *ngIf="!item[cardImageProperty]">
                            {{ getImagePlaceholder(item) }}
                        </div>
                        <img class="item-image"
                            [src]="getUrl(item[cardImageProperty])"
                            *ngIf="item[cardImageProperty]"
                            [alt]="item[cardTitleProperty] || 'Item'">
                    </div>

                    <!-- Título e Subtítulo -->
                    <div class="card-title-container">
                        <h3 class="card-title"
                            [matTooltip]="item[cardTitleProperty] || getPrimaryPropertyValue(item)">
                            {{ item[cardTitleProperty] ||
                            getPrimaryPropertyValue(item) || 'Item' }}
                        </h3>
                        <span class="card-type-badge"
                            *ngIf="showBadge && item[badgeProperty]">
                            {{ item[badgeProperty] }}
                        </span>
                    </div>

                    <!-- Indicador de Seleção -->
                    <div class="selection-indicator"
                        *ngIf="isItemSelected(item) || selectedItem?.id === item.id">
                        <mat-icon color="primary">check_circle</mat-icon>
                    </div>
                </div>

                <!-- Conteúdo do Card -->
                <div class="card-content">
                    <ng-container
                        *ngFor="let property of getPrimaryProperties()">
                        <div class="info-row"
                            *ngIf="property !== cardTitleProperty && property !== cardImageProperty && property !== badgeProperty">
                            <span class="info-label">{{
                                getConfigForProperty(property)?.display ||
                                property }}:</span>
                            <span class="info-value">
                                <ng-container
                                    *ngIf="item[property] !== null && item[property] !== undefined; else noValue">
                                    <span
                                        [innerHTML]="getConfigForProperty(property) ?
                                    getValue(getConfigForProperty(property),
                                    item) : item[property]"></span>
                                </ng-container>
                                <ng-template #noValue>Não definido</ng-template>
                            </span>
                        </div>
                    </ng-container>
                </div>

                <!-- Rodapé do Card (Ações) -->
                <div class="card-footer">
                    <!-- Status/Badge para cards desativados -->
                    <div
                        *ngIf="item[lockProperty] === false || item.isActive === false"
                        class="inactive-badge">
                        DESATIVADO
                    </div>

                    <!-- Botões de Ação -->
                    <div class="action-buttons"
                        *ngIf="!(item[lockProperty] === false || item.isActive === false)">
                        <button
                            mat-icon-button
                            matTooltip="Visualizar"
                            *ngIf="!item.hideShow"
                            (click)="$event.stopPropagation(); showRow(item)">
                            <mat-icon class="btn-show">remove_red_eye</mat-icon>
                        </button>

                        <button
                            mat-icon-button
                            matTooltip="Editar"
                            *ngIf="!item.hideEdit && isEditableShow"
                            [disabled]="!isEditableEnabled"
                            (click)="$event.stopPropagation(); isEditableEnabled && editRow(item)">
                            <mat-icon
                                [ngClass]="isEditableEnabled ? 'btn-edit' : 'btn-edit:disabled'">edit</mat-icon>
                        </button>

                        <button
                            mat-icon-button
                            matTooltip="Excluir"
                            *ngIf="!item.hideDelete && isDeletableShow"
                            [disabled]="!isDeletableEnabled"
                            (click)="$event.stopPropagation(); isDeletableEnabled && deleteRow(item)">
                            <mat-icon
                                [ngClass]="isDeletableEnabled ? 'btn-delete' : 'btn-delete:disabled'">delete</mat-icon>
                        </button>

                        <button
                            mat-icon-button
                            matTooltip="Bloquear"
                            *ngIf="showLock && isLockActionShow && item[lockProperty]"
                            [disabled]="!isLockActionEnabled"
                            (click)="$event.stopPropagation(); isLockActionEnabled && lockItem(item)">
                            <mat-icon class="btn-lock">lock</mat-icon>
                        </button>

                        <button
                            mat-icon-button
                            matTooltip="Desbloquear"
                            *ngIf="showLock && isLockActionShow && !item[lockProperty]"
                            [disabled]="!isLockActionEnabled"
                            (click)="$event.stopPropagation(); isLockActionEnabled && unlockItem(item)">
                            <mat-icon class="btn-unlock">lock_open</mat-icon>
                        </button>

                        <button
                            mat-icon-button
                            matTooltip="Informações"
                            *ngIf="showInfo"
                            (click)="$event.stopPropagation(); infoItem(item)">
                            <mat-icon class="btn-info">info</mat-icon>
                        </button>

                        <!-- Adicione outros botões específicos conforme necessário -->
                    </div>
                </div>
            </mat-card>
        </div>

        <!-- Paginador -->
        <mat-paginator
            *ngIf="!hidePagination && !isLoading"
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent($event)">
        </mat-paginator>

        <ng-content select="[footer]"></ng-content>
    </div>
</div>